import { motion } from "framer-motion";

export const LibraryMosaic = ({ items, caption, testId = "library-mosaic", gridClass = "grid-cols-4 gap-2 sm:grid-cols-7 sm:gap-3" }) => (
  <figure data-testid={testId} className="relative">
    <div className={`grid ${gridClass}`}>
      {items.map((p, i) => (
        <motion.div
          key={p.name}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: (i % 7) * 0.06, ease: [0.22, 1, 0.36, 1] }}
          className={`group relative aspect-square overflow-hidden border border-ink/10 bg-white ${i % 2 === 1 ? "sm:translate-y-4" : ""}`}
          title={p.name}
        >
          <img
            src={p.img}
            alt={`Okładka: ${p.name}`}
            loading="lazy"
            className="h-full w-full object-contain p-2 transition-transform duration-500 ease-out group-hover:scale-[1.06]"
          />
        </motion.div>
      ))}
    </div>
    {caption && (
      <figcaption className="mt-8 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/55 sm:mt-10">
        <span className="h-px w-8 bg-red" />
        {caption}
      </figcaption>
    )}
  </figure>
);
